import { getSomethingGoesWrongMessage } from '../../../../common/messages/error';

export const CLIENT_BALANCE_ERROR_MSG = getSomethingGoesWrongMessage({
  reason: 'while retrieving your wallet balance',
  userPossibleAction: 'refreshing the app to get the latest information',
  contactSupport: true
});
